
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Chip
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import moment from 'moment';
import { getFormState } from '../../../helpers/form';
import dayjs from 'dayjs';
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useQuery } from '../../../helpers/common';
import {Notice} from '../../components/notice';
const API_HOST = CONFIG.modules['accounts'].host



const items = {
    'Employees': {
        name: 'Employees',
        view: ''
    },


}

const fields = [
    {
        type: 'text',
        label: 'Employee Name',
        required: true,
        name: 'name'
    },
    {
        type: 'text',
        label: 'Email',
        required: true,
        name: 'email'
    },
    {
        type: 'text',
        label: 'Phone',
        required: true,
        name: 'phone'
    },
    {
        type: 'password',
        label: 'Password',
        required: true,
        name: 'password'
    },
    {
        type: 'group',
        items: [
            {
                type: 'date',
                label: 'Date of Birth',
                required: true,
                name: 'dob',
                defaultValue: dayjs()
            },
            {
                type: 'date',
                label: 'Date of Joining',
                required: true,
                name: 'dateOfJoining',
                defaultValue: dayjs()
            },
        ]
    },


    {
        type: 'select',
        label: 'Department Type',
        option: { key: 'department_types', value: '_id', label: 'name' },
        required: true,
        defaultValue: 'Core',
        name: 'department_type',
    },
    {
        type: 'select',
        label: 'Departments',
        option: { key: 'DepartmentsFiltered', value: '_id', label: 'name' },
        required: true,
        name: 'departments',
        multiple: true
    },



    {
        type: 'select',
        label: 'Designation',
        option: { key: 'Designations', value: '_id', label: 'name' },
        required: true,
        name: 'designation',
        multiple: true
    },
    {
        type: 'select',
        label: 'Reporting Manager',
        option: { key: 'users', value: '_id', label: 'name' },
        name: 'reportingManager'
    },
    {
        type: 'select',
        label: 'POC',
        option: { key: 'users', value: '_id', label: 'name' },
        name: 'pocForLeaves'
    },

    {
        type: 'select',
        label: 'Roles',
        required: true,
        name: 'roles',
        multiple: true,
        option: { key: 'roles', value: '_id', label: 'name' }

    },

    {
        type: 'select',
        label: 'Languages',
        option: { key: 'Languages', value: '_id', label: 'name' },
        name: 'languages',
        multiple: true
    },
    {
        type: 'select',
        label: 'Districts',
        option: { key: 'Districts', value: '_id', label: 'name' },
        name: 'district'
    },
  
]

export const EmployeeProfile = (props) => {
    const { roles, user, users, Designations, Departments, Languages, Districts } = useSelector((state) => (state.user || {}))
    const userStore = useSelector((state) => (state.user || {}))

    const history = useHistory();

    const query = useQuery()

    const [DepartmentsFiltered, setDepartmentsFiltered] = useState([])
    const [active, setActive] = useState('Employees')

    const [savedData, setSavedData] = useState(null)
    const [formData, setFormData] = useState(getFormState(fields))

    const [changed, setChanged] = useState(false)

    const [savedMessage, setSavedMessage] = useState(false)

    useEffect(() => {
        console.log(DepartmentsFiltered)
        console.log(formData, DepartmentsFiltered)
    }, [DepartmentsFiltered])

    useEffect(() => {
        if (formData.department_type) {
            setDepartmentsFiltered((Departments || []).filter(e => e.type == formData.department_type))
            const newFormData = { ...formData }
            formData.departments = []
            setFormData({ ...newFormData })
        }
    }, [formData.department_type])


    useEffect(() => {

    }, [active])

    useEffect(() => {
    }, [Designations])

    useEffect(() => {
    }, [userStore])

    const parseData = (newData) => {
        newData.password = ''
        newData.dob = dayjs(newData.dob)
        newData.dateOfJoining = dayjs(newData.dateOfJoining)
        if (newData.departments) {
            newData.departments = newData.departments.map(d => d._id)
        }
        if (newData.designation) {
            newData.designation = newData.designation.map(d => d._id)
        }
        return newData;
    }

    useEffect(() => {
        axios.get(API_HOST + `/users/${query.get('id')}`).then((resp) => {
            if (resp.data && resp.data.success) {
                const newData = parseData({ ...resp.data.detail })

                setFormData(newData)
                setSavedData(newData)
            }
        }).catch((e) => {
            console.log(e)
        })
    }, [])



    const handleEdit = () => {
        if (formData.password == '') {
            delete formData.password
        }
        
        axios.put(API_HOST + `/${query.get('id')}`, {
            user: formData
        }).then((resp) => {
            if (resp.data && resp.data.success) {
                const newData = parseData({ ...resp.data.detail })
                setChanged(false)
                setSavedData(newData)
                setSavedMessage('User saved successfully!')
                setTimeout(()=> {
                    setSavedMessage(null)
                }, 2000)
            }
        }).catch((e) => {
            console.log(e)
        })
    }
    const reset = () => {
        setChanged(false)
        setFormData({ ...savedData })
    }


    return (
        <>
        {
            savedMessage &&
            <Notice text={savedMessage}/>
        }
       
            {
                changed &&
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', right: 20, bottom: 30, position: 'fixed', background: 'white', padding: 1, zIndex: 5, mb: 0 }}>
                    <Button key={0} onClick={reset} variant='Outlined' >{'Discard'}</Button>
                    <Button key={1} onClick={handleEdit} sx={{ ml: 2 }} variant='contained'>{'Save'}</Button>
                </Box>
            }



            <Tabs items={items} active={active} onChange={(key) => {
                setActive(key)
            }} />
            <ToolBar
                // name={active}
                breadCrumbs={{
                    list: [
                        { name: active, link: '/hr/employee-management' }
                    ], active: {
                        name: 'Details', link: '/hr/employee-management/detail'

                    }
                }}
            />
            <Box sx={{ mt: 2 }}>
                {
                    Array.isArray(fields) &&
                    <FormA fields={fields}
                        data={{
                            roles, Designations, Districts, Languages, Departments, DepartmentsFiltered, users, department_types: [
                                {
                                    _id: 'Core',
                                    name: 'Core'
                                },
                                {
                                    _id: 'Project Based',
                                    name: 'Project Based'
                                }

                            ]
                        }}
                        onChange={(name, value, multiple) => {
                            formData[name] = value
                            setFormData({ ...formData })
                            setChanged(true)
                        }}
                        state={formData || {}}
                    />
                }
            </Box>





        </>
    )
}